const metersToPixelsAtMaxZoom = (meters, latitude) =>
  meters / 0.075 / Math.cos((latitude * Math.PI) / 180);

export const MARKERS = {
  secondary: {
    "circle-stroke-width": 4,
    "circle-radius": 10,
    "circle-blur": 0.15,
    "circle-color": "#d1179e",
    "circle-stroke-color": "white",
  },
  primary: {
    "circle-stroke-width": 4,
    "circle-radius": 10,
    "circle-blur": 0.15,
    "circle-color": "#661a88",
    "circle-stroke-color": "white",
  },
  radius({ radius, lat }) {
    return {
      "circle-radius": {
        stops: [
          [0, 0],
          [20, metersToPixelsAtMaxZoom(radius * 1000, lat)],
        ],
        base: 2,
      },
      "circle-color": "#661a88",
      "circle-opacity": 0.15,
    };
  },
};

